import styled from "@emotion/styled";

export const ErrorContent = styled.div`
  margin: 64px 56px 0 56px;
  text-align: center;
`;
